module.exports = __webpack_public_path__ + "img/IMG-20181201-WA0009.ee05615f.jpg";